import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["fill"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m0.79375 0v0.79375h-0.79375v0.52917h0.79375v0.79375h0.52917v-0.79375h0.79375v-0.52917h-0.79375v-0.79375z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    width: "8",
    height: "8",
    version: "1.1",
    viewBox: "0 0 2.1167 2.1167",
    xmlns: "http://www.w3.org/2000/svg",
    fill: _ctx.color
  }, _hoisted_3, 8, _hoisted_1))
}